import type { PartialMessage } from "@bufbuild/protobuf";
import { ClientContext } from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/models_pb";
import type {
  ConversationClientContext,
  ConversationClientScenario,
  ConversationFSSClientScenario,
  ConversationFSSClientScenarioSources,
} from "../types";

// Simple wrapper around the ClientContext constructor
// that ensures type safety around clientScenario as it is typed as a string on the backend
export function createConversationClientContext(
  scenario: ConversationClientScenario,
  options?: Omit<PartialMessage<ClientContext>, "clientScenario">,
): ConversationClientContext {
  return new ClientContext({
    clientScenario: scenario as string,
    ...options,
  });
}

/**
 * Creates a client context for an FSS conversation with the given scenario and sources.
 * If we need to add additional metadata to the context, we can expand this definition.
 * @param clientScenario - The FSS client scenario to use.
 * @param sources - The sources to use for the FSS conversation.
 * @returns The client context for the FSS conversation.
 */
export const createFssClientContextWithSources = (
  clientScenario: ConversationFSSClientScenario,
  sources: ConversationFSSClientScenarioSources,
): ConversationClientContext => {
  return createConversationClientContext(clientScenario, {
    clientScenarioId: JSON.stringify({
      sources,
    }),
  });
};
